<template>
	<div class="search-brand">
		<label class="search-brand__label">
			<input
				:class="['search-brand__input--medium', inputClass]"
				ref="input"
				type="search"
				v-model="brandName"
				@keyup="typingBrand($event)"
				@keyup.down.prevent="selectByArrow(0, true)"
				@keypress.enter.prevent="$emit('enter')"
				:placeholder="searcherPlaceholder"
				:disabled="disabled"
			/>
		</label>

		<ul class="search-brand__brand-selector" v-if="showSearchBrand">
			<li
				v-for="(brand, idx) in clientBrandList"
				:key="brand.idBrand"
				ref="selectorList"
			>
				<button
					class="search-brand__brand-selector__btn"
					type="button"
					@keydown.up.prevent="
						selectByArrow(idx === 0 ? 'input' : idx - 1)
					"
					@keydown.down.prevent="
						selectByArrow(
							idx + 1 === clientBrandList.length ? idx : idx + 1
						)
					"
					@click="setClientBrand(brand)"
				>
					{{ getBrandLabel(brand) }})
				</button>
			</li>
		</ul>
	</div>
</template>
<script>
	import debounce from 'lodash/debounce';

	export default {
		name: 'BrandSelector',
		props: {
			inputClass: {
				type: String,
			},
			disabled: {
				type: Boolean,
				default: false,
			},
			showIfIsDisplay: {
				type: Boolean,
				default: false,
			},
			propName: {
				type: [String, Boolean],
				default: false,
			},
			searcherPlaceholder: {
				type: String,
				default: '브랜드 검색(초성검색 가능)',
			},
			selectedPlaceholder: {
				type: String,
				default: '클라이언트를 선택해 주세요',
			},
			useLastBrand: {
				type: Boolean,
				default: false,
			},
			exceptBrandIds: {
				type: Array,
				default: () => [],
			},
			selectBrandTitle: {
				type: String,
				default: '',
			},
			brandNames: {
				type: String,
				default: '',
			},
		},
		data() {
			return {
				showSearchBrand: false,
				clientBrandList: [],
				brandName: this.brandNames ?? '',
			};
		},
		watch: {
			selectBrandTitle() {
				this.brandName = this.selectBrandTitle;
			},
			brandNames() {
				this.brandName = this.brandNames;
			},
		},
		mounted() {
			if (this.selectBrandTitle) {
				this.brandName = this.selectBrandTitle;
			}
		},
		methods: {
			selectByArrow(idx, fromInput) {
				const selectorList = this.$refs.selectorList;
				if (fromInput) {
					this.$refs.input.focus();
					setTimeout(() => {
						selectorList[idx]
							.querySelector('.search-brand__brand-selector__btn')
							.focus();
					});
					return;
				}
				if (!selectorList || idx === 'input') {
					this.$refs.input.focus();
					return;
				}
				selectorList[idx]
					.querySelector('.search-brand__brand-selector__btn')
					.focus();
			},
			typingBrand(e) {
				const arrowKeyCode = [37, 38, 39, 40];
				if (arrowKeyCode.includes(e.keyCode)) {
					return;
				} else {
					this.searchBrand(e);
				}
			},
			searchBrand: debounce(function (event) {
				if (event.target.value.trim().length > 0) {
					const keyword = _.last(event.target.value.split('] '));
					this.$axiosAdmin2
						.get(
							`/api/brands?searchWord=${keyword}&offset=0&limit=100`
						)
						.then(({ data }) => {
							this.clientBrandList = data.data
								.map(brand => ({
									...brand,
									brandTitle:
										this.showIfIsDisplay && !brand.isDisplay
											? `[비전시] ${brand.brandTitle}`
											: brand.brandTitle,
								}))
								.filter(
									brand =>
										!this.exceptBrandIds.includes(
											brand.idBrand
										)
								)
								.sort((a, b) => b.isDisplay - a.isDisplay);

							this.showSearchBrand =
								this.clientBrandList.length > 0;
						});
				} else {
					this.showSearchBrand = false;
					this.init();
				}
			}, 500),
			async setBrandOnlyId(id) {
				const { data } = await this.$axiosAdmin2.get(
					`/api/brands?idBrand=${id}&offset=0&limit=1`
				);
				const brandObj = data.data[0];
			},
			setClientBrand(brand) {
				this.showSearchBrand = false;
				this.clientBrandList = [];
				this.brandName = this.getBrandLabel(brand);
				this.$refs.input.value = this.getBrandLabel(brand);
				this.$emit('change', brand);
			},
			init() {
				this.$emit('init');
				this.$refs.input.value = '';
				this.$emit('change', null);
			},
			async getLastBrand() {
				try {
					const { data } =
						await this.$axiosAdmin2.get('/api/brands/latest');
					const idBrand = data.data.idBrand;
					const brandTitle = data.data.brandTitle;
					this.$emit('change', idBrand);
				} catch (err) {
					console.error(err);
					alert(
						'최근 등록한 브랜드 블러오기에 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			getBrandLabel(brand) {
				if (brand) {
					const brandName = brand.isDisplay
						? `[${brand.idBrand}] ${brand.brandTitle}`
						: `[${brand.idBrand}][미전시] ${brand.brandTitle}`;
					return brandName;
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	div {
		.search-brand {
			position: relative;
			display: inline-block;
			font-size: 0;
		}

		.search-brand__label {
			display: inline-block;
			font-size: 0.875rem;
			margin-right: 8px;
		}

		.search-brand__input--medium {
			width: 300px;
		}

		.search-brand__brand-selector {
			position: absolute;
			overflow: scroll;
			z-index: 999;
			width: 300px;
			min-height: 100px;
			max-height: 300px;
			background-color: #fff;
			border: solid 1px #dfe6ee;
			border-radius: 5px;
			padding: 1em 0;
			font-size: 0.875rem;
		}

		.search-brand__brand-selector__btn {
			padding: 0.5em 1em;
			cursor: pointer;

			&:focus,
			&:hover {
				background: #f4f7fa;
			}
		}

		.search-brand__clear {
			display: inline-block;
			margin: 3px 8px 0 0;
			vertical-align: top;
			font-size: 0.875rem;
		}

		.search-brand__last-brand {
			display: inline-block;
			margin-top: 3px;
		}
	}
</style>
